module.exports = __webpack_public_path__ + "img/p3_4.0eb0ae32.webp";